module.exports = {
  "adobe-experience-manager-dark": "0 0 16 17",
  "adobe-experience-manager": "0 0 16 17",
  "apple-app-store-dark": "0 0 140 140",
  "apple-app-store": "0 0 140 140",
  "bigcommerce-dark": "0 0 140 140",
  "bigcommerce-lockup-dark": "0 0 291 66",
  "bigcommerce-lockup": "0 0 291 66",
  "bigcommerce": "0 0 140 140",
  "bitly-dark": "0 0 140 64",
  "bitly": "0 0 140 64",
  "bynder-dark": "0 0 18 14",
  "bynder": "0 0 18 14",
  "canva-dark": "0 0 140 140",
  "canva": "0 0 140 140",
  "dropbox-dark": "0 0 140 119",
  "dropbox-lockup-dark": "0 0 291 57",
  "dropbox-lockup": "0 0 291 57",
  "dropbox-wordmark-dark": "0 0 308 71",
  "dropbox-wordmark": "0 0 308 71",
  "dropbox": "0 0 140 119",
  "facebook-audience-network-dark": "0 0 140 145",
  "facebook-audience-network": "0 0 140 145",
  "facebook-dark": "0 0 141 139",
  "facebook-groups-dark": "0 0 140 140",
  "facebook-groups": "0 0 140 140",
  "facebook-shops-dark": "0 0 141 155",
  "facebook-shops": "0 0 141 155",
  "facebook": "0 0 141 139",
  "feedly-dark": "0 0 141 123",
  "feedly": "0 0 141 123",
  "glassdoor-dark": "0 0 140 196",
  "glassdoor": "0 0 140 196",
  "google-analytics-dark": "0 0 140 160",
  "google-analytics": "0 0 140 160",
  "google-business-messages-dark": "0 0 140 140",
  "google-business-messages": "0 0 140 140",
  "google-drive-dark": "0 0 140 126",
  "google-drive": "0 0 140 126",
  "google-my-business-dark": "0 0 140 123",
  "google-my-business": "0 0 140 123",
  "google-play-store-dark": "0 0 140 155",
  "google-play-store": "0 0 140 155",
  "hubspot-dark": "0 0 140 156",
  "hubspot": "0 0 140 156",
  "instagram-dark": "0 0 140 140",
  "instagram": "0 0 140 140",
  "linkedin-audience-network-dark": "0 0 140 141",
  "linkedin-audience-network": "0 0 140 141",
  "linkedin-dark": "0 0 140 140",
  "linkedin": "0 0 140 140",
  "marketo-dark": "0 0 140 164",
  "marketo": "0 0 140 164",
  "messenger-dark": "0 0 140 141",
  "messenger": "0 0 140 140",
  "microsoft-dynamics-dark": "0 0 140 227",
  "microsoft-dynamics": "0 0 140 227",
  "pinterest-dark": "0 0 140 141",
  "pinterest": "0 0 140 141",
  "reddit-dark": "0 0 140 140",
  "reddit": "0 0 140 140",
  "salesforce-dark": "0 0 140 99",
  "salesforce": "0 0 140 99",
  "shopify-dark": "0 0 140 159",
  "shopify": "0 0 140 159",
  "slack-dark": "0 0 140 140",
  "slack": "0 0 140 140",
  "sproutsocial-dark": "0 0 140 174",
  "sproutsocial-lockup-dark": "0 0 291 58",
  "sproutsocial-lockup": "0 0 291 58",
  "sproutsocial-wordmark-dark": "0 0 320 52",
  "sproutsocial-wordmark": "0 0 320 52",
  "sproutsocial": "0 0 140 174",
  "tiktok-dark": "0 0 140 159",
  "tiktok": "0 0 140 159",
  "tripadvisor-dark": "0 0 140 140",
  "tripadvisor": "0 0 140 140",
  "tumblr-dark": "0 0 140 140",
  "tumblr": "0 0 140 140",
  "twitter-audience-network-dark": "0 0 140 140",
  "twitter-audience-network": "0 0 140 140",
  "twitter-dark": "0 0 140 114",
  "twitter": "0 0 140 114",
  "whatsapp-dark": "0 0 140 140",
  "whatsapp": "0 0 140 141",
  "woocommerce-dark": "0 0 140 84",
  "woocommerce": "0 0 140 84",
  "yelp-dark": "0 0 140 159",
  "yelp": "0 0 140 159",
  "youtube-dark": "0 0 140 99",
  "youtube": "0 0 140 99",
  "zendesk-dark": "0 0 140 107",
  "zendesk-lockup-dark": "0 0 160 115",
  "zendesk-lockup": "0 0 160 115",
  "zendesk-wordmark-dark": "0 0 350 67",
  "zendesk-wordmark": "0 0 350 67",
  "zendesk": "0 0 140 107"
};